import styled from 'styled-components';

export const NoteClickToChart = styled.img`
   display: none;
   float: right;
   margin: 0;
   width: 150px;

   @media only screen and (min-width: 1200px) {
      display: block;
      position: absolute;
      bottom: 0;
      right: 17px;
   }
`;
